var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMicrophone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 29,
    viewBox: "0 0 21 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.0737 13.5655C20.0737 12.9881 19.6071 12.5215 19.0297 12.5215C18.4523 12.5215 17.9857 12.9881 17.9857 13.5655C17.9857 17.9551 14.4265 21.5143 10.0369 21.5143C5.64721 21.5143 2.08805 17.9551 2.08805 13.5655C2.08805 12.9881 1.6214 12.5215 1.04402 12.5215C0.466648 12.5215 0 12.9881 0 13.5655C0.00790927 18.6986 3.88345 23.0013 8.98493 23.5312V26.0621H4.81674C4.23937 26.0621 3.77272 26.5288 3.77272 27.1062C3.77272 27.6835 4.271 28.1423 4.84838 28.1423H15.257C15.8343 28.1423 16.301 27.6756 16.301 27.0983C16.301 26.5209 15.8343 26.0542 15.257 26.0542H11.0967V23.5233C16.1982 22.9933 20.0737 18.6986 20.0737 13.5655Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0526 19.7023C13.4299 19.6943 16.1744 16.9577 16.1744 13.5805V6.17741C16.206 2.79224 13.4932 0.031911 10.108 0.000273917C6.72283 -0.0313631 3.9625 2.68151 3.93086 6.06668C3.93086 6.10623 3.93086 6.14577 3.93086 6.18532V13.5726C3.92296 16.9498 6.65956 19.7023 10.0526 19.7023C10.0447 19.7023 10.0447 19.7023 10.0526 19.7023ZM6.011 6.20114C6.03473 3.97073 7.86968 2.17532 10.1001 2.20696C12.2989 2.23069 14.0705 4.01027 14.0943 6.20114V13.5884C14.0705 15.8188 12.2356 17.6142 10.0052 17.5826C7.8064 17.5588 6.03473 15.7793 6.011 13.5884V6.20114Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophone);
export default __webpack_public_path__ + "static/media/microphone.495646120b6871dad5e4769edd25cfa9.svg";
export { ForwardRef as ReactComponent };